import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/ceLogo2.svg'


const _withScopeId = n => (_pushScopeId("data-v-09fa6160"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center h-screen px-6 bg-color-blue-gradient" }
const _hoisted_2 = { class: "w-full max-w-sm p-6 bg-white rounded-md shadow-md" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold text-gray-700" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo large-logo",
      src: _imports_0
    })
  ])
], -1))
const _hoisted_4 = { class: "flex justify-between mt-4 row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "block text-sm fontme hover:underline primary-color mt-1",
  href: "https://app.club-employes.com/reset-password/"
}, " Mot de passe oublié ? ", -1))
const _hoisted_6 = {
  key: 0,
  class: "text-center text-red-500 mt-2"
}
const _hoisted_7 = { class: "w-full mt-4" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth/authStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {


const router = useRouter();
const authStore = useAuthStore();
const user = ref({ username: '', password: '' });
const isConnecting = ref(false);
const errorMessage = ref('');
const login = async () => {
    isConnecting.value = true;
    errorMessage.value = '';
    try {
        const login = await authStore.login(user.value);
        if (200 === login.status) {
            await router.push({ name: 'dashboard' });
        }
        
        if (202 === login.status) {
            localStorage.setItem('userEmail', user.value.username);
            await router.push({ name: 'CheckGoogle2FaCode' });
        }
    } catch (error) {
        console.dir(error);
        errorMessage.value = 'Vos identifiants sont incorrects.';
    } finally {
        isConnecting.value = false;
    }
};
const handleIconClick = (node, e) => {
    node.props.suffixIcon = node.props.suffixIcon === 'eye' ? 'eyeClosed' : 'eye'
    node.props.type = node.props.type === 'password' ? 'text' : 'password'
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_FormKit, {
        type: "form",
        actions: false,
        onSubmit: login,
        "incomplete-message": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FormKit, {
            type: "email",
            name: "email",
            modelValue: user.value.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.username) = $event)),
            validation: "required|email",
            "validation-label": "Email",
            placeholder: "Email",
            "validation-messages": {
                    required: 'Ce champ est requis',
                    email: 'Veuillez saisir une adresse email valide'
                }
          }, null, 8, ["modelValue"]),
          _createVNode(_component_FormKit, {
            type: "password",
            name: "password",
            modelValue: user.value.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.password) = $event)),
            validation: "required",
            "validation-label": "Password",
            placeholder: "Password",
            "validation-messages": {
                    required: 'Ce champ est requis'
                },
            "suffix-icon": "eyeClosed",
            onSuffixIconClick: handleIconClick,
            "suffix-icon-class": "hover:text-blue-500"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FormKit, {
              type: "checkbox",
              name: "remember",
              label: "Se souvenir de moi",
              class: "mr-2 text-indigo-600 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
            }),
            _hoisted_5
          ]),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_FormKit, {
              type: "submit",
              style: {"display":"flex","justify-content":"center","align-items":"center","background-color":"#041D4B","border-radius":"5px","border":"none","cursor":"pointer","width":"100%","text-align":"center"},
              label: "Se connecter"
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})